import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import OutlinedInput from '@mui/material/OutlinedInput';



export default class Login extends Component {
	
	 constructor(props) {
    super(props);
	 this.state = {Username:'',Password:'',btndisabled:false,pagename:'',errormessage:'',loginerropen:false,checked:true,showPassword:false,errortype:"error",btnlogdisabled:false,btnLogintext:'Login'}
	 }
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
handleChange = (event) => 
{
	this.setState({checked: !this.state.checked});
};
handleClickShowPassword = (event) => 
{
	this.setState({showPassword: !this.state.showPassword});
};
componentDidMount() {

	if(localStorage.getItem("ISIuserid")!==null)
	{
		if(localStorage.getItem("ISIrole")!=="1")
	{
		this.setState({
						redirect: true,
							pagename:'/Compdashboard'	
							
						  })
	}
	else if(localStorage.getItem("ISIrole")==="1"){
		this.setState({
						redirect: true,
							pagename:'/AdminCompany'	
							
						  })
	}

						  
	}else{
		if(localStorage.getItem("ISIUsername")!=null)
		{
		this.setState({
							Username: localStorage.getItem("ISIUsername"),
							Password: localStorage.getItem("ISIpwd"),
						  }) 
		}
		}
		
	

}
handleClickLogin= (event) => 
		{
		event.preventDefault();
				
				let Username = this.state.Username;
				let Password = this.state.Password;
				let ischeck = this.state.checked;
		const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
				if(Username==''){
						
				this.setState({errormessage:"Please Enter Email id",loginerropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
				}else{
					 if (!remail.test(Username)) {
						 this.setState({errormessage:"Please Enter Valid Email Id",erroropen:true});
							 window.scrollTo({        top: 0     })
						return false; 
  }
				}
			
				if(Password==''){
						this.setState({errormessage:"Please Enter Password",loginerropen:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
			this.setState({	btnlogdisabled:true,btnLogintext:'Processing...',errormessage:'',loginerropen:false});
				
				
var formData = new FormData();
				formData.append('action','Login') 	
 
				formData.append('us_emailid',Username)
				formData.append('us_password',Password)
				
	
	
				axios.post(localStorage.getItem("ISIurl")+"ajaxuser.php", formData, {
				}).then(res => {
				
				
				if(res.data.length>0){
					if(res.data[0]["verify"]==="blocked")
					{
							this.setState({	btnlogdisabled:false,btnLogintext:'Login',errormessage:'Your Account is blocked, please contact admin',loginerropen:true});
							window.scrollTo({        top: 0     })
					}
					else if(res.data[0]["verify"]==="wp")
					{
							this.setState({	btnlogdisabled:false,btnLogintext:'Login',errormessage:'Invalid Username and Password',loginerropen:true});
							window.scrollTo({        top: 0     })
					}
					else if(res.data[0]["verify"]==="v")
					{
							
							window.scrollTo({        top: 0     })
					
					if(ischeck==true)
					  {
						  
						   localStorage.setItem("ISIUsername",Username);
						  localStorage.setItem("ISIpwd",Password);
						
					  }
					  else{
							 localStorage.removeItem("ISIUsername");
							  localStorage.removeItem("ISIpwd"); 
						  }
				localStorage.setItem("ISIUsername",Username);
				localStorage.setItem("ISIuserid",res.data[0].us_id);
				localStorage.setItem("ISIrole",res.data[0].us_role);
				localStorage.setItem("ISIcmpid",res.data[0].us_cmp_id);
				localStorage.setItem("ISIcmpname",res.data[0].cmp_name);
				
			if(res.data[0].us_role==="1")
			{
				 this.setState({btnlogdisabled:false,btnLogintext:'Login',errormessage:'',loginerropen:false,redirect: true,
							pagename:'/AdminCompany'});
			}else{
				
			   this.setState({	btnlogdisabled:false,btnLogintext:'Login',errormessage:'',loginerropen:false,redirect: true,
							pagename:'/Compdashboard'});
			}
		 				}
				

				
				}
				else
				{
					this.setState({errormessage:"Not a valid login details",loginerropen:true,btnLogintext:'Login',	btnlogdisabled:false,});
		 window.scrollTo({        top: 0     })
				}
				
				});
				
				
			
		}
				
	 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
	render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return (
<React.Fragment>
<Serverurl/>
<div className="loginmain">
<div className="mainscreen-row">
<div className="main">
	<div className="leftbandlog-col">
		
		
		
	</div>
	<div className="contentseclog-col">
	<div className="contentseclog-collog">
		<div className="logindiv">
		<h1>Isifol Accounting</h1>
		<p>Enter your email address to get started.</p>
			 <p>  <Collapse in={this.state.loginerropen}>
							<Alert
							  action={
								<IconButton
								  aria-label="close"
								  color="inherit"
								  size="small"
								  onClick={() => {
								   this.handleErrorclose();
								  }}
								>
								  <CloseIcon fontSize="inherit" />
								</IconButton>
							  } severity={this.state.errortype}
							>
							{this.state.errormessage}
							</Alert>
					</Collapse></p>
					
			<p><TextField id="txtUsername" className="txtbox" fullWidth  variant="outlined" name="Username" value={this.state.Username}  inputProps={{tabIndex: "1",maxLength:150}} onChange={this.myChangeHandler} placeholder="Email id"/></p>
			<p>
			 <FormControl className="txtbox" >
          
          <OutlinedInput id="txtPassword" name="Password" className="txtbox" value={this.state.Password}  inputProps={{tabIndex: "2",maxLength:15}} onChange={this.myChangeHandler} placeholder="Password"
            type={this.state.showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                
                >
                  {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
</p>
			<p> <FormControlLabel 
        label="Remember me"
        control={ <Checkbox  checked={this.state.checked}  onChange={this.handleChange}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
			
			<Button disabled={this.state.btnlogdisabled} variant="contained" className="frmPrimarybtn" onClick={this.handleClickLogin}>
 {this.state.btnLogintext} 
</Button>
			
		</div>
	</div>
		</div>
	<div className="clear"></div>
</div>
</div>
</div>
</React.Fragment>
)

	}		
}







